import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { audiences } from '../data/content';
export function AudienceSection() {
  return <section className="w-full bg-ink py-16 sm:py-24" aria-label="Who it is for" data-id="element-20" data-mp="s0un8hhavbzv">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-21" data-mp="wznye3946qwv">
        <SectionHeading title={<>
              Built for technicians who need <span className="text-volt" data-id="element-23" data-mp="3vimhk2iws818">practical answers</span>
            </>} sub="The Automotive Parasitic Drain Diagnostic Blueprint™ is designed for:" data-id="element-22" data-mp="wyct1z00tb3n" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-24" data-mp="99237ck7l14a">
          {audiences.map(a => {
          const Icon = a.icon;
          return <li key={a.title} className="flex gap-4 rounded-2xl bg-navy p-5 lg:flex-col" data-id="element-25" data-mp="3cqtok83uamti">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-spark/15" data-id="element-26" data-mp="3hpwvxz7al54n">
                  <Icon className="h-6 w-6 text-spark" aria-hidden="true" data-id="element-27" data-mp="14aj7t3b9ov13" />
                </div>
                <div data-id="element-28" data-mp="zbpvvfbmpc31">
                  <h3 className="font-display text-2xl font-extrabold uppercase leading-none text-white" data-id="element-29" data-mp="zbfzn9zzq8ow">
                    {a.title}
                  </h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-mist" data-id="element-30" data-mp="uimvooccj4dv">{a.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-10 max-w-3xl text-center text-base text-white sm:text-lg" data-id="element-31" data-mp="ll4anjypcq1z">
          Whether you’re dealing with an overnight battery discharge, intermittent electrical activity, or a
          suspected module that remains awake, this blueprint helps you organize your next diagnostic steps.
        </p>

        <SectionCta label="This is for me — get access" data-id="element-32" data-mp="7mmovrscxnmp" />
      </div>
    </section>;
}